// extracted by mini-css-extract-plugin
export default {"content":"page_content__bRNZp","loadingIndicator":"page_loadingIndicator__VswgQ"};